import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider, RequireAuth } from "@/auth";
import { Layout } from "@/components/Layout";
import { Login } from "@/pages/Login";
import { Analytics } from "@/pages/Analytics";
import { Submissions } from "@/pages/Submissions";
import { Tenants } from "@/pages/Tenants";
import { TenantDetail } from "@/pages/TenantDetail";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, "")}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<Analytics />} />
            <Route path="/submissions" element={<Submissions />} />
            <Route path="/tenants" element={<Tenants />} />
            <Route path="/tenants/:key" element={<TenantDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
